import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-document",
  "use": "icon-document-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-document\"><path d=\"M959.008 355.008l-14 0 0-102c0-35.344-28.656-64-64-64l-400 0L481.008 131.008c0-35.344-28.656-64-64-64l-352 0c-35.344 0-64 28.656-64 64l0 762c0 35.344 28.656 64 64 64l816 0c35.344 0 64-28.656 64-64l78-474C1023.008 383.664 994.352 355.008 959.008 355.008zM49.008 163.008c0-35.344 12.656-48 48-48l288 0c35.344 0 48 12.656 48 48l0 74 2 0 46 0 368 0c35.344 0 48 12.656 48 48l0 70L143.008 355.008c-35.344 0-64 28.656-64 64L49.008 613.616 49.008 163.008zM897.008 861.008c0 35.344-12.656 48-48 48l-752 0c-35.344 0-48-12.656-48-48l78-410c0-35.344 12.656-48 48-48l752 0c35.344 0 48 12.656 48 48L897.008 861.008z\" p-id=\"40939\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/document.svg
// module id = hzSG
// module chunks = 29